import React, { useState, useEffect } from 'react';
import { FormControl, TextField, Grid, Box, Card, CardContent, Typography, CardActions, Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar, frFR } from '@mui/x-data-grid';
import Cookies from 'js-cookie'

import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { getUserRule } from '../../utils/userRule';
import Autorize from '../../components/ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Rapport_all_club_datagrid({ secteur, annee })
{

    const [listClub, setListClub] = useState([]);
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");


    /*
     const MyAxios = axios.create({
         headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
         withCredentials: true,
         xsrfCookieName: 'token',
         xsrfHeaderName: 'X-XSRF-TOKEN',
     })*/
    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })

    useEffect(() => {



        const fetchData = async () => {
            try {

                let RuleReport = await getUserRule("read_reports", sessionStorage.getItem('clubId'), sessionStorage.getItem('secteur'));
                setAutorize(RuleReport);

            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };
        fetchData(); // Appel de la fonction asynchrone




        if (autorize) {

            //, { headers: { Authorization: "Bearer "+ cookies }}
            MyAxios.get(process.env.REACT_APP_API + '/rapports/getcluboverview/')   //'+ secteur + "/"+ annee) //axios.defaults.withCredentials = true
                .then((res) => {
                    setErrorAxios(false);
                  // console.log(res.data);
                    setListClub(res.data);

                })
                .catch((error) => {
                    console.log(error)
                    ///  if(error.status)  
                    if (error.response.status === 401)// pas autorisé
                        setErrorAxios(true);

                });
        }

    }, [secteur, annee, autorize]);


    const navigate = useNavigate();
    const dispatch = useDispatch();



    const columns = [       
        { field: 'id', headerName: 'Numéro de club', width: 100, },
        { field: 'ClubLegalName', headerName: 'Nom légal du club', width: 400, },
        { field: 'City', headerName: 'Ville', width: 250, },
        { field: 'Status', headerName: 'Statut', width: 125, },
        { field: 'State_Province_Code', headerName: 'Province', width: 100, },
        { field: 'Date_Added', headerName: 'Date de fondation', width: 125, },
        { field: 'clubFacebook', headerName: 'Facebook', width: 250, },
        { field: 'clubEmail', headerName: 'Courriel', width: 250, },
        { field: 'clubSiteWeb', headerName: 'Site Web', width: 250, },       
        { field: 'prioritejeunesse_membre', headerName: 'Priorite jeunesse membre', width: 160, },
        { field: 'priorite_jeunesse_dateformation', headerName: 'Priorite jeunesse date formation', width: 160, },
        { field: 'loi25_membre', headerName: 'Loi25 membre', width: 160, },
        { field: 'loi25_dateformation', headerName: 'Loi25 Date formation', width: 160, },
        { field: 'solde', headerName: 'Solde dû', type: 'number', width: 160, }

    ];

    //  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}


    return (
        <div>
            <Autorize axiosError={errorAxios} />

            <div style={{ height: 900,  width: '90%', margin: '3%' }}>
                <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                    rows={listClub}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    components={{ Toolbar: GridToolbar }}
                    initialState={{
                        filter: {
                            filterModel: {
                                items: [{ columnField: 'Status', operatorValue: 'equals', value: 'A' }],
                            },
                        },
                    }}

                />


            </div>

        </div>

    );

};

export default Rapport_all_club_datagrid;